/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import ColorPickerComponent from '../../customizeComponentLayout/colorPicker';
import { ReactComponent as AccordionExpand } from '../../../assets/icons/accordionExpand.svg';
import { ReactComponent as AccordionHide } from '../../../assets/icons/accordionHide.svg';
import { customStyles } from '../../customizeComponentLayout/styles';
import AlignmentComponent from '../../customizeComponentLayout/alignment';
import '../customize.scss';
import { ConnectedProps, connect } from 'react-redux';
import {
  customPaddingbottom,
  customPaddingleft,
  customPaddingright,
  customPaddingtop,
  fontColor,
  fontSize,
  fontType,
  setAlignment,
  setBtnColor,
  setBtnType,
  inactivefontColor,
  fontStyle,
  SetChecklistBgColor,
  setBorderBottom,
  setBorderColor,
  setBorderLeft,
  setBorderRadius,
  setBorderRight,
  setBorderStyle,
  setBorderTop,
  setFontWeight,
  SetHeaderFontColor,
  ChecklistBodyFontStyle,
  ChecklistBodyFontSize,
  ChecklistBodyFontWeight,
  CheckBoxColor,
  ChecklistBodyFontColor,
  SetChecklistBodyAlignment,
  setHandleStrike,
  SetBodyFontFamily,
} from '../../../redux/button/button';
import SpaceComponent from '../../customizeComponentLayout/spaceComponent';
import FontHandlerComponent from '../../customizeComponentLayout/fontHandler';
import BorderCustomizeComponent from '../../customizeComponentLayout/borderCustomize';

const mapState = ({ button }: any) => ({
  color: button.color,
  btnType: button.btnType,
  fontFamily: button.fontFamily,
  fontStyle: button.fontStyle,
  fontSize: button.fontSize,
  alignment: button.alignment,
  fontColor: button.fontColor,
  errors: button.errors,
  customPaddingtop: button.customPaddingtop,
  customPaddingleft: button.customPaddingleft,
  customPaddingbottom: button.customPaddingbottom,
  customPaddingright: button.customPaddingright,
  ChecklistBgColor: button.ChecklistBgColor,
  borderLeft: button.borderLeft,
  borderTop: button.borderTop,
  borderRight: button.borderRight,
  borderBottom: button.borderBottom,
  borderStyle: button.borderStyle,
  borderRadius: button.borderRadius,
  borderColor: button.borderColor,
  fontWeight: button.fontWeight,
  headerFontColor: button.headerFontColor,
  checklistBodyFontStyle: button.checklistBodyFontStyle,
  checklistBodyFontSize: button.checklistBodyFontSize,
  checklistBodyFontWeight: button.checklistBodyFontWeight,
  ChecklistBodyFontColor: button.ChecklistBodyFontColor,
  checkBoxColor: button.checkBoxColor,
  checklistBodyAlignment: button.checklistBodyAlignment,
  strike: button.strike,
  bodyFontFamily: button.bodyFontFamily,
  fontWeightForHeader: button.fontWeightForHeader,
});

const mapDispatch = (dispatch: Function) => ({
  SetButtonColor: (data: { color: string }) => dispatch(setBtnColor(data)),
  SetButtonType: (data: { btnType: string }) => dispatch(setBtnType(data)),
  SetFontFamily: (data: { fontFamily: string }) => dispatch(fontType(data)),
  SetFontStyle: (data: { fontStyle: string }) => dispatch(fontStyle(data)),
  SetFontSize: (data: { fontSize: string }) => dispatch(fontSize(data)),
  Setalignment: (data: { alignment: string }) => dispatch(setAlignment(data)),
  SetFontColor: (data: { fontColor: string }) => dispatch(fontColor(data)),
  SetInactiveFontColor: (data: { inactivefontColor: string }) => dispatch(inactivefontColor(data)),
  SetcustomPaddingtop: (data: { customPaddingtop: string }) => dispatch(customPaddingtop(data)),
  SetcustomPaddingleft: (data: { customPaddingleft: string }) => dispatch(customPaddingleft(data)),
  SetcustomPaddingbottom: (data: { customPaddingbottom: string }) =>
    dispatch(customPaddingbottom(data)),
  SetcustomPaddingright: (data: { customPaddingright: string }) =>
    dispatch(customPaddingright(data)),
  SetChecklistBgColor: (data: { ChecklistBgColor: string }) => dispatch(SetChecklistBgColor(data)),
  SetBorderTop: (form: any) => dispatch(setBorderTop(form)),
  SetBorderBottom: (form: any) => dispatch(setBorderBottom(form)),
  SetBorderRight: (form: any) => dispatch(setBorderRight(form)),
  SetBorderLeft: (form: any) => dispatch(setBorderLeft(form)),
  SetBorderRadius: (form: any) => dispatch(setBorderRadius(form)),
  BorderColor: (form: any) => dispatch(setBorderColor(form)),
  HandleBorderStyle: (form: any) => dispatch(setBorderStyle(form)),
  HandleFontWeight: (form: any) => dispatch(setFontWeight(form)),
  SetHeaderFontColor: (data: { headerFontColor: string }) => dispatch(SetHeaderFontColor(data)),
  SetChecklistBodyFontStyle: (data: { fontStyle: string }) =>
    dispatch(ChecklistBodyFontStyle(data)),
  SetChecklistBodyFontSize: (data: { fontSize: string }) => dispatch(ChecklistBodyFontSize(data)),
  HandleChecklistBodyFontWeight: (data: { fontWeight: string }) =>
    dispatch(ChecklistBodyFontWeight(data)),
  setCheckBoxColor: (data: { checkBoxColor: string }) => dispatch(CheckBoxColor(data)),
  SetChecklistBodyFontColor: (data: { ChecklistBodyFontColor: string }) =>
    dispatch(ChecklistBodyFontColor(data)),
  SetChecklistBodyAlignment: (data: { alignment: string }) =>
    dispatch(SetChecklistBodyAlignment(data)),
  HandleStrike: (form: any) => dispatch(setHandleStrike(form)),
  SetBodyFontFamily: (data: { fontFamily: string }) => dispatch(SetBodyFontFamily(data)),
});

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = { fontFamilyPropsList: any; contentType: any } & ConnectedProps<
  typeof connector
>;

type Props = PropsFromRedux;

const ButtonCustomize = (props: Props) => {
  const [opened, setOpened] = useState('button');

  const toggleCollapse = (id: string) => {
    setOpened((prevAccordion: string) => (prevAccordion === id ? '' : id));
  };

  const getButtonDisplayType = () => {
    switch (props.btnType) {
      case 'btn btn-square btn-dark':
        return 'Fill';
      case 'btn btn-outline-dark':
        return 'Outline';
      case 'btn btn-pill btn-dark':
        return 'Pill';
      default:
        return '';
    }
  };
  const istButton = props.contentType === 'Button';

  return (
    <Accordion className='designsec-accordion' defaultActiveKey='button'>
      <Accordion.Item eventKey='button' className='border-0 my-3'>
        <Accordion.Header
          as='div'
          className={`custom-header-title m-0 ${opened === 'button' && 'selected-section'}`}
          onClick={() => toggleCollapse('button')}
        >
          {opened === 'button' ? <AccordionExpand /> : <AccordionHide />}
          <div
            className={`px-2 ${opened === 'button' ? 'selected-section' : 'header-section-title'}`}
          >
            {istButton ? props.contentType : 'Check List'}
          </div>
        </Accordion.Header>
        <Accordion.Body className='px-2'>
          {istButton && (
            <>
              <FontHandlerComponent
                componentType='Type'
                setFontProperty={props.SetButtonType}
                fontPropertyValue={getButtonDisplayType()}
                options={customStyles.buttonType}
              />

              <AlignmentComponent
                alignmentValue={props.alignment}
                SetAlignmentValue={props.Setalignment}
              />
            </>
          )}
          <SpaceComponent
            componentType='Padding'
            left={props.customPaddingleft}
            top={props.customPaddingtop}
            right={props.customPaddingright}
            bottom={props.customPaddingbottom}
            SetLeft={props.SetcustomPaddingleft}
            SetTop={props.SetcustomPaddingtop}
            SetRight={props.SetcustomPaddingright}
            SetBottom={props.SetcustomPaddingbottom}
          />
          {!istButton && (
            <>
              <ColorPickerComponent
                type='checklistbgColor'
                title='Background Color'
                SetColor={props.SetChecklistBgColor}
                color={props.ChecklistBgColor}
              />
              <BorderCustomizeComponent
                borderLeft={props.borderLeft}
                borderTop={props.borderTop}
                borderRight={props.borderRight}
                borderBottom={props.borderBottom}
                SetBorderLeft={props.SetBorderLeft}
                SetBorderRight={props.SetBorderRight}
                SetBorderBottom={props.SetBorderBottom}
                SetBorderTop={props.SetBorderTop}
                borderStyle={props.borderStyle}
                SetBorderStyle={props.HandleBorderStyle}
                borderRadius={props.borderRadius}
                SetBorderRadius={props.SetBorderRadius}
                borderColor={props.borderColor}
                SetBorderColor={props.BorderColor}
              />
            </>
          )}
          {istButton && (
            <>
              <FontHandlerComponent
                componentType='Font Family'
                setFontProperty={props.SetFontFamily}
                fontPropertyValue={props.fontFamily}
                options={customStyles.fontFamily}
                customFonts={props.fontFamilyPropsList}
                setFontStyle={props.SetFontStyle}
                fontStyleValue={props.fontStyle}
              />
              <FontHandlerComponent
                componentType='Font Size'
                setFontProperty={props.SetFontSize}
                fontPropertyValue={props.fontSize}
                options={customStyles.fontSize}
              />
              <ColorPickerComponent
                type='btnFontColor'
                title='Font Color'
                SetColor={props.SetFontColor}
                color={props.fontColor}
              />
              <ColorPickerComponent
                type='btnbgColor'
                title='Background Color'
                SetColor={props.SetButtonColor}
                color={props.color}
              />
              <AlignmentComponent
                alignmentValue={props.alignment}
                SetAlignmentValue={props.Setalignment}
              />
            </>
          )}
        </Accordion.Body>
      </Accordion.Item>
      {!istButton && (
        <>
          <Accordion.Item eventKey='header' className='border-0 my-3'>
            <Accordion.Header
              as='div'
              className={`custom-header-title m-0 ${opened === 'header' && 'selected-section'}`}
              onClick={() => toggleCollapse('header')}
            >
              {opened === 'header' ? <AccordionExpand /> : <AccordionHide />}
              <div className='px-2 section-header-title'>Header</div>
            </Accordion.Header>

            <Accordion.Body>
              <FontHandlerComponent
                componentType='Font Family'
                setFontProperty={props.SetFontFamily}
                fontPropertyValue={props.fontFamily}
                options={customStyles.fontFamily}
                customFonts={props.fontFamilyPropsList}
                setFontStyle={props.SetFontStyle}
                fontStyleValue={props.fontStyle}
              />
              <FontHandlerComponent
                componentType='Font Size'
                setFontProperty={props.SetFontSize}
                fontPropertyValue={props.fontSize}
                options={customStyles.fontSize}
              />
              <FontHandlerComponent
                componentType='Font Weight'
                setFontProperty={props.HandleFontWeight}
                fontPropertyValue={props.fontWeightForHeader}
                options={customStyles.fontWeight}
              />
              <AlignmentComponent
                alignmentValue={props.alignment}
                SetAlignmentValue={props.Setalignment}
              />
              <ColorPickerComponent
                type='ChecklistHeaderFontColor'
                title='Font Color'
                SetColor={props.SetHeaderFontColor}
                color={props.headerFontColor}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey='Body' className='border-0 my-3'>
            <Accordion.Header
              as='div'
              className={`custom-header-title m-0 ${opened === 'Body' && 'selected-section'}`}
              onClick={() => toggleCollapse('Body')}
            >
              {opened === 'Body' ? <AccordionExpand /> : <AccordionHide />}
              <div className='px-2 section-header-title'>Body</div>
            </Accordion.Header>

            <Accordion.Body>
              <FontHandlerComponent
                componentType='Font Family'
                setFontProperty={props.SetBodyFontFamily}
                fontPropertyValue={props.bodyFontFamily}
                options={customStyles.fontFamily}
                customFonts={props.fontFamilyPropsList}
                setFontStyle={props.SetChecklistBodyFontStyle}
                fontStyleValue={props.checklistBodyFontStyle}
              />
              <FontHandlerComponent
                componentType='Font Size'
                setFontProperty={props.SetChecklistBodyFontSize}
                fontPropertyValue={props.checklistBodyFontSize}
                options={customStyles.fontSize}
              />
              <FontHandlerComponent
                componentType='Font Weight'
                setFontProperty={props.HandleChecklistBodyFontWeight}
                fontPropertyValue={props.checklistBodyFontWeight}
                options={customStyles.fontWeight}
              />
              <AlignmentComponent
                alignmentValue={props.checklistBodyAlignment}
                SetAlignmentValue={props.SetChecklistBodyAlignment}
              />
              <ColorPickerComponent
                type='checklistFontColor'
                title='Font Color'
                SetColor={props.SetChecklistBodyFontColor}
                color={props.ChecklistBodyFontColor}
              />
              <ColorPickerComponent
                type='ChecklistColor'
                title='CheckBox Color'
                SetColor={props.setCheckBoxColor}
                color={props.checkBoxColor}
              />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey='Behavioural' className='border-0 my-3'>
            <Accordion.Header
              as='div'
              className={`custom-header-title m-0 ${
                opened === 'Behavioural' && 'selected-section'
              }`}
              onClick={() => toggleCollapse('Behavioural')}
            >
              {opened === 'Behavioural' ? <AccordionExpand /> : <AccordionHide />}
              <div className='px-2 section-header-title'>Behavioural Settings</div>
            </Accordion.Header>

            <Accordion.Body>
              <div className=' icon-items container-inner'>
                <div className='behaviour-container'>
                  <Form.Check
                    type='switch'
                    className='switch-dark'
                    id='custom-switch1'
                    label='Strike'
                    checked={props.strike}
                    onChange={() =>
                      props.HandleStrike({
                        strike: !props.strike,
                      })
                    }
                  />
                  <small id='emailHelp' className='m-0 form-text helper-text'>
                    {`strike line will ${props.strike ? '' : 'not'} be shown in checklist items`}
                  </small>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </>
      )}
    </Accordion>
  );
};

export default connector(ButtonCustomize);
